<template>
  <tree-select ref="treeSelect" :props="props" :options="data" :value="value1" :parent-select="pSelect" :clearable="clearable" placeholder="请选择"
    @node-select="select($event)" />
</template>
<script>
import treeSelect from "@/components/common/treeSelect";
export default {
  components: { treeSelect },
  props: {
    value: {},
    pSelect: {
      type: Boolean,
      default: true,
    },
    options: {
      type: Array,
      default: () => []
    },
    isInit: {
      type: Boolean,
      default: true
    },
    clearable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      api: require("@/api/ent/dp").default,
      value1: null,
      data: [],
      props: {
        // 配置项（必选）
        value: "DpId",
        label: "DpName",
        children: "children",
      },
    };
  },
  mounted() {
    this.value1 = this.value;
    console.log("mounted", this.value1);
    if (this.isInit) {
      this.init();
    } else {
      this.data = this.$commonJs.toTreeData(this.options, "DpId");
      this.$refs.treeSelect.setData();
    }
  },
  watch: {
    value() {
      this.value1 = this.value;
      // console.log("watch", this.value1);
      if (this.value1) this.setData(this.value1)
    },
    options() {
      this.data = this.$commonJs.toTreeData(this.options, "DpId");
      this.$refs.treeSelect.setData();
    }
  },
  methods: {
    init(params = {}) {
      params = { ...params, Status: 1 };
      // console.log("init", params);
      this.api.list(params).then((res) => {
        // res.Data[0].DpName = "开发部";
        this.data = this.$commonJs.toTreeData(res.Data, "DpId");
        this.$refs.treeSelect.setData();
      });
    },
    setData(value) {
      this.value1 = value
      this.$refs.treeSelect.setData();
    },
    clear() {
      this.$refs.treeSelect.clearHandle();
    },
    select(e) {
      if (e) this.$emit("input", e.DpId);
      else this.$emit("input", null);
      this.$emit("node-click", e);
    },
  },
};
</script>